import Add from '@material-ui/icons/Add'
import React from 'react'
import Fade from 'react-reveal/Fade'
import InvoiceForm from '../../components/Invoice/InvoiceForm/InvoiceForm'
import Alert from '../../components/UI/Alert/Alert'
import Button from '../../components/UI/Button/Button'
import DatePicker from '../../components/UI/DatePicker/DatePicker'
import Input from '../../components/UI/Input/Input'
import Search from '../../components/UI/Search/Search'
import Table from '../../components/UI/Table/Table'
import FetchData from '../../shared/fetchData'
import { updateObject } from '../../shared/utility'
import { saveAs } from "file-saver"

const Invoices = (props) => {

    const [rerender, setRerender] = React.useState(false)
    const [pageSize, setPageSize] = React.useState(10)
    const [pageIndex, setPageIndex] = React.useState(0)
    const [pageCount, setPageCount] = React.useState(0)
    const [tableData, setTableData] = React.useState([])
    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [units, setUnits] = React.useState([])
    const [invoices, setInvoices] = React.useState([])
    const [invoice, setInvoice] = React.useState('')
    const [loading, setLoading] = React.useState(false)
    const [edit, setEdit] = React.useState(false)
    const [newInvoicePage, setNewInvoicePage] = React.useState(false)
    const [showAlert, setShowAlert] = React.useState(false)
    const [alertContent, setAlertContent] = React.useState('')
    const [permission, setPermission] = React.useState(window.localStorage.getItem("permission"))
    const [searchParams, setSearchParams] = React.useState({
        description: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شرح صورتحساب'
            },
            validation: {
                required: true
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })

    React.useEffect(() => {
        setPageIndex(0)
        setPageSize(10)
        setPageCount(0)
        const search = searchParams
        for (let key in search) {
            search[key].value = ''
        }
        setSearchParams(search)
        var raw = JSON.stringify({
            "pl": 1000,
            "pn": 1,
            "version": "mtpx001"
        })
        var url = 'management/api/v1/units/getUnits'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    setUnits(result.units)
                }
            })
            .catch(error => console.log(error))
    }, [])

    const inputChangedHandler = (event, controlName) => {
        const updatedControls = updateObject(searchParams, {
            [controlName]: updateObject(searchParams[controlName], {
                value: event.target.value
            })
        });
        setSearchParams(updatedControls)
    }

    const toggleNewInvoiceForm = (event, value) => {
        if (value == false) {
            search();
        }
        setNewInvoicePage(value)
    }

    const invoicePrintSubmit = (id) => {
        var raw = JSON.stringify({
            "invoice": {
                "id": id,
                // "serial": invoice.serial.value
            },
            "version": "mtpx001"
        })
        var url = 'management/api/v1/reports/invoicePrint'
        setLoading(true)
        FetchData(raw, url)
            .then(result => {
                return result.blob().then(blob => {
                    const name = 'invoice.pdf';
                    saveAs(blob, name);
                });
            })
            .catch(error => setLoading(false))
    }
    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            "filter": {
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "description": searchParams['description'].value != null && searchParams['description'].value != '' ? "%" + searchParams['description'].value + "%" : null
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/invoices/getInvoices'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.invoices)
                    pushData(newList)
                    setInvoices(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }

    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'description',
                header: 'شرح صورتحساب',
                align: 'center',
            },
            {
                accessorKey: 'sellerName',
                header: 'فروشنده',
                align: 'center',
            },
            {
                accessorKey: 'buyerName',
                header: 'خریدار',
                align: 'center',
            },
            {
                accessorKey: 'registerDate',
                header: 'تاریخ ثبت',
                align: 'center',
            },
            {
                accessorKey: 'fromDate',
                header: "از تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'toDate',
                header: "تا تاریخ",
                align: 'center',
            },
            {
                accessorKey: 'endDate',
                header: "مبلغ(ریال)",
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                description: d.description,
                sellerName: d.sellerName,
                buyerName: d.buyerName,
                registerDate: d.registerDate,
                fromDate: d.fromDate,
                toDate: d.toDate,
                invoiceAmount: d.invoiceAmount != null && d.invoiceAmount != '' ? d.invoiceAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '',
                subRows: [],
            });
        })
        const prmsn = window.localStorage.getItem("permission");
        buttons.push({ id: 1, text: 'چاپ صورتحساب', clicked: invoicePrintSubmit });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }

    const search = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }
    const refresh = (event) => {
        const srch = searchParams
        for (let key in srch) {
            srch[key].value = ''
        }
        setSearchParams(srch)
        getData({ pageIndex: pageIndex, pageSize: pageSize }, true)
    }

    const addNewInvoice = (event, id) => {
        setInvoice('')
        setEdit(false)
        toggleNewInvoiceForm(event, true)
    }
    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }
    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }
    const showInvoiceAlert = (event, show, content) => {
        setShowAlert(show)
        setAlertContent(content)
        setTimeout(() => {
            setShowAlert(false)
        }, 4000)
    }
    const formElementsArray = [];
    for (let key in searchParams) {
        formElementsArray.push({
            id: key,
            config: searchParams[key]
        })
    }
    let form = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                search={true}
                col="3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    })
    form = <div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            {form}
            <DatePicker change={changeFromDate} value={from} placeHolder="تاریخ ثبت از" col="3" />
            <DatePicker change={changeToDate} value={to} placeHolder="تاریخ ثبت تا" col="3" />
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-2">
                <Button btnType="search-btn" clicked={search}>جستجو</Button>
            </div>
        </div>
    </div>
    return (
        <div>
            {!newInvoicePage ?
                <Fade duration={200} left cascade>
                    <div>
                        <Search class="orders-search" form={form} />
                        {permission != null && permission.includes('INVOICE_WRITE') ?
                            <div className="row justify-content-center mt-3 ml-3">
                                <div className="UserGeneralBtn">
                                    <div onClick={(event) => addNewInvoice(event)} className="Add">
                                        <Add className="UserIcon" />
                                    </div>
                                </div>
                            </div>
                            : ''
                        }
                        {rerender ?
                            // <Spinner />
                            <Table pageSize={pageSize} hasDetails={false} data={invoices} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                            :
                            <Table pageSize={pageSize} hasDetails={false} data={invoices} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                        }
                    </div>
                </Fade>
                :
                <InvoiceForm units={units} edit={edit} invoice={edit ? invoice : ''} toggleNewInvoiceForm={toggleNewInvoiceForm} showInvoiceAlert={showInvoiceAlert} />
            }
            {showAlert == true ?
                <div class="row justify-content-center mt-5">
                    <div>
                        <Alert variant="error" class="mt-3" text={alertContent} />
                    </div>
                </div>
                : ''}
        </div>
    )
}

export default Invoices